import { render, staticRenderFns } from "./NodeItem.vue?vue&type=template&id=be8930c0&scoped=true"
import script from "./NodeItem.vue?vue&type=script&lang=js"
export * from "./NodeItem.vue?vue&type=script&lang=js"
import style0 from "./NodeItem.vue?vue&type=style&index=0&id=be8930c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8930c0",
  null
  
)

export default component.exports